import { render, staticRenderFns } from "./TImg.vue?vue&type=template&id=243c1446&"
import script from "./TImg.vue?vue&type=script&lang=js&"
export * from "./TImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports